import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { ProductSeoFriendlyNameLlmQuickWinRootParamList } from "../../../../types";
import React from "react";
import { ScreenContext } from "./common";
import { useFormContext } from "react-hook-form";
import { ProductFormValues } from "../../components/ProductForm/types";
import { ProductSeoFriendlyNameReviewScreen } from "./ProductSeoFriendlyNameReviewScreen";

export type ProductSeoFriendlyNameLlmQuickWinRootScreenProps = StackScreenProps<
  any,
  "ProductSeoFriendlyNameLlmQuickWinRootScreen"
>;

const StackNavigator =
  createStackHeaderNavigator<ProductSeoFriendlyNameLlmQuickWinRootParamList>();
export const ProductSeoFriendlyNameLlmQuickWinRootScreen = ({
  navigation,
}: ProductSeoFriendlyNameLlmQuickWinRootScreenProps) => {
  const { setValue: setProductFormValue, getValues } =
    useFormContext<ProductFormValues>();

  // need to use a screen context so the child form does not overwrite the parent form context
  const handleOnSubmit = ({ name }: { name: string }) => {
    setProductFormValue("name", name, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    navigation.pop();
  };

  return (
    <ScreenContext.Provider
      value={{
        onSubmit: handleOnSubmit,
        originalFormValues: getValues(), // incase we need other data
      }}
    >
      <StackNavigator.Navigator
        screenOptions={{
          headerShown: true,
          headerLeft: () => <ModalCloseButton type="Cancel" />,
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          title: "",
        }}
      >
        <StackNavigator.Screen
          name="ProductSeoFriendlyNameReviewScreen"
          component={ProductSeoFriendlyNameReviewScreen}
        />
      </StackNavigator.Navigator>
    </ScreenContext.Provider>
  );
};
